import { IJwtWithApiKey, getJwtTokenFullDataFromApiKey } from 'multirpc-sdk';

import { decryptJWT } from './decryptJWT';

export type ResolveJWTWithApiKeyParams = Pick<
  IJwtWithApiKey,
  'api_key' | 'is_encrypted' | 'jwt_data'
>;

// The *WithApiKey endpoints convert the JWT on the backend. An encrypted JWT
// comes back unconverted (conversion_status: 'skipped_encrypted_jwt'), so it
// still has to be decrypted by the wallet and imported on the client.
export const resolveJWTWithApiKey = async (
  params: ResolveJWTWithApiKeyParams,
) =>
  getJwtTokenFullDataFromApiKey(params) ??
  decryptJWT({ isEncrypted: params.is_encrypted, jwt: params.jwt_data });
